//  Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { push } from 'react-router-redux'
import initializeAFSGridFilter from 'redux/modules/interferenceAnalysis/thunks/initializeAFSGridFilter'
import updateAnalysisResults from 'redux/modules/interferenceAnalysis/thunks/updateAnalysisResults'

const goToAfsGrid = analysisStatus => async dispatch => {
  const { projectId } = analysisStatus

  const analysisTypeId = analysisStatus.analysisTypeId.toString()
  const bandId = analysisStatus.bandId.toString()

  const afsGridFilterOverrideValues = {
    analysisTypeId,
    bandId,
  }

  const pathname = `/project-management/${projectId}/interference-analysis`

  // if we're already on the 'newRoute',
  // then we need to manually trigger the AFS grid to update.
  // otherwise go to there!
  // NOTE - this is assuming hash routing
  if (window.location.hash === `#${pathname}`) {
    await dispatch(initializeAFSGridFilter(afsGridFilterOverrideValues))
    dispatch(updateAnalysisResults())
  } else {
    dispatch(push({
      pathname,
      state: {
        afsGridFilterOverrideValues,
      }
    }))
  }
}

export default goToAfsGrid
